import { dayjs } from "../../date";
const entryToDate = (date, format) => {
  if (typeof date === 'string') return dayjs(date, format, true).toDate();
  if (typeof date === 'number') return new Date(date);
  return date;
};
const valid = (date, format) => {
  if (!date) return true;
  const dateObj = dayjs(date, format, true);
  return dateObj.isValid();
};
const min = (date, format, min) => {
  if (!date) return true;
  const dateObj = dayjs(date, format, true);
  if (dateObj.isValid()) {
    const valueDate = dateObj.toDate();
    const minDate = entryToDate(min, format);
    return minDate.getTime() < valueDate.getTime();
  }
  return false;
};
const max = (date, format, max) => {
  if (!date) return true;
  const dateObj = dayjs(date, format, true);
  if (dateObj.isValid()) {
    const valueDate = dateObj.toDate();
    const maxDate = entryToDate(max, format);
    return maxDate.getTime() > valueDate.getTime();
  }
  return false;
};
export const date = {
  valid,
  min,
  max
};